"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('bus', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(0.000000, -0.963812)"
  }, _react.default.createElement("path", {
    d: "M6.0123992,34.9688383 L6.0123992,9 C6.0123992,7.8954305 6.9078297,7 8.0123992,7 L40,7 C41.1045695,7 42,7.8954305 42,9 L42,34.9688383 C42,36.6256925 40.6568542,37.9688383 39,37.9688383 L37.0048665,37.9688383 L37.0048665,38.9638122 C37.0048665,41.1729512 35.2140055,42.9638122 33.0048665,42.9638122 L33.0044775,42.9638122 C30.7953385,42.9638122 29.0044775,41.1729512 29.0044775,38.9638122 L29.0044775,37.9688383 L19.0079217,37.9688383 L19.0079217,38.9654529 C19.0079217,41.1736858 17.2177953,42.9638122 15.0095624,42.9638122 C12.8013295,42.9638122 11.011203,41.1736858 11.011203,38.9654529 L11.011203,37.9688383 L9.0123992,37.9688383 C7.35554495,37.9688383 6.0123992,36.6256925 6.0123992,34.9688383 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M42,23.9638122 L6,23.9638122",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("rect", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    x: "14",
    y: "13.9638122",
    width: "20",
    height: "10"
  }), _react.default.createElement("path", {
    d: "M14,30.9638122 L16,30.9638122",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M32,30.9638122 L34,30.9638122",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;